import { SvgIconProps } from '@mui/material';
import React from 'react';
import exclamation from '../../icons/exclamation-circle.svg';
import { Icon } from './Icon';

/** Error Exclamation */
export function ErrorIcon(props: SvgIconProps) {
  return <Icon dataCy="exclamation-icon" glyph={exclamation} {...props} />;
}
